import { Box, Typography } from "@mui/material"

const Item = (props) => {
  const { title, description, created_at, src } = props

  return (
    <Box sx={{ mb: 6 }}>
      <Box component="img" alt="Image" src={src} sx={{ width: "100%" }} />
      <Typography variant="caption">{created_at}</Typography>
      <Typography variant="body1" sx={{ my: 1, fontWeight: 500 }}>
        {title}
      </Typography>
      <Typography variant="body2">{description}</Typography>
    </Box>
  )
}

export default Item
